import { isUserAllowed } from '@lumapps/permissions';

const isRoleAllowed = isUserAllowed();

export { isRoleAllowed };
